import React, { useState } from "react";
import { submitLeadGeneration } from "../utils/auth";
const LeadSearchForm = () => {
  const [formData, setFormData] = useState({
    location: "",
    industry: "",
    jobTitle: "",
    keywords: "",
    maxResults: 100,
  });

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert({ type: "", message: "" });

    if (!formData.location || !formData.industry || !formData.jobTitle || !formData.keywords) {
      setAlert({ type: "danger", message: "All fields are required." });
      return;
    }

    try {
      setLoading(true);
       await submitLeadGeneration(formData);
      setAlert({ type: "success", message: "Lead generation submitted successfully. You will receive the leads by email shortly." });
    } catch (err) {
      setAlert({ type: "danger", message: `Failed to submit leads. ${err.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lead-search-shell">
      <div className="dashboard-card lead-search-card">
            <h2 className="lead-search-title">Lead Search Form</h2>
            <p className="lead-search-subtitle">
              Submit targeting details for the lead generation workflow.
            </p>
            {alert.message && (
              <div className={`alert alert-${alert.type} text-center`} role="alert">
                {alert.message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  name="location"
                  placeholder="e.g. Pune, India"
                  value={formData.location}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Industry / Sector</label>
                <input
                  type="text"
                  className="form-control"
                  name="industry"
                  placeholder="e.g. Civil Engineering"
                  value={formData.industry}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Job Title / Role</label>
                <input
                  type="text"
                  className="form-control"
                  name="jobTitle"
                  placeholder="e.g. Survey Manager"
                  value={formData.jobTitle}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Keywords</label>
                <input
                  type="text"
                  className="form-control"
                  name="keywords"
                  placeholder="e.g. CAD Drafting"
                  value={formData.keywords}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Max Results</label>
                <input
                  type="number"
                  className="form-control"
                  name="maxResults"
                  min="10"
                  max="1000"
                  value={formData.maxResults}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-primary fw-bold rounded-3" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span> Submitting
                    </>
                  ) : (
                    "Search Leads"
                  )}
                </button>
              </div>
            </form>
      </div>
    </div>
  );
};

export default LeadSearchForm;
